// Premium (voice reminders) subscription — client helpers.
// Normal notifications stay free for everyone; only voice is gated.
import { API_BASE } from '../config'

export async function fetchSubscriptionStatus(fetchWithAuth) {
  try {
    const r = await fetchWithAuth(`${API_BASE}/api/subscription/status`)
    if (!r.ok) return { premium: false }
    return await r.json()
  } catch { return { premium: false } }
}

const loadRazorpay = () => new Promise(resolve => {
  if (window.Razorpay) return resolve(true)
  const s = document.createElement('script')
  s.src = 'https://checkout.razorpay.com/v1/checkout.js'
  s.onload = () => resolve(true)
  s.onerror = () => resolve(false)
  document.body.appendChild(s)
})

// Full purchase flow: create order → Razorpay checkout → verify+activate.
// Resolves { premium, validUntil } on success, throws Error on failure/cancel.
export async function subscribePremium(fetchWithAuth, user) {
  const loaded = await loadRazorpay()
  if (!loaded) throw new Error('Could not load payment gateway. Check your connection.')

  const orderRes = await fetchWithAuth(`${API_BASE}/api/subscription/create-order`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
  const order = await orderRes.json()
  if (!orderRes.ok || !order.id) throw new Error(order.message || 'Could not start payment.')

  const key = order.keyId || process.env.REACT_APP_RAZORPAY_KEY_ID
  if (!key) throw new Error('Payment not configured.')

  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key,
      order_id: order.id,
      amount: order.amount,
      currency: order.currency || 'INR',
      name: 'Revive Skin & Hair',
      description: 'Voice Reminders — Premium (1 month)',
      image: '/logo192.png',
      prefill: { name: user?.name || '', contact: user?.email || '' },
      theme: { color: '#0F3D24' },
      handler: async (resp) => {
        try {
          const vr = await fetchWithAuth(`${API_BASE}/api/subscription/activate`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ razorpay_order_id: resp.razorpay_order_id, razorpay_payment_id: resp.razorpay_payment_id, razorpay_signature: resp.razorpay_signature }),
          })
          const data = await vr.json()
          if (!vr.ok || !data.premium) return reject(new Error(data.message || 'Payment verification failed.'))
          resolve(data)
        } catch (e) { reject(new Error('Could not confirm payment.')) }
      },
      modal: { ondismiss: () => reject(new Error('cancelled')) },
    })
    rzp.on('payment.failed', r => reject(new Error(r?.error?.description || 'Payment failed.')))
    rzp.open()
  })
}
